import moment from 'moment';

export const LAST_WEEK_DATE_FILTER = moment().utc().subtract(7, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]');

export const LAST_MONTH_DATE_FILTER = moment().utc().subtract(1, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]');

export const LAST_THREE_MONTHS_DATE_FILTER = moment().utc().subtract(3, 'months').format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]');

export const LAST_YEAR_DATE_FILTER = moment().utc().subtract(1, 'years').format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]');

export const SINCE_EVER_DATE_FILTER = moment()
  .utc()
  .subtract(100, 'years')
  .startOf('year')
  .startOf('day')
  .startOf('month')
  .format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]');

export const DASHBOARD_FILTER_LIST = [
  { key: 0, name: 'dashboard.widgets.lastWeek', filter: LAST_WEEK_DATE_FILTER },
  { key: 1, name: 'dashboard.widgets.lastMonth', filter: LAST_MONTH_DATE_FILTER },
  { key: 2, name: 'dashboard.widgets.lastMonths', filter: LAST_THREE_MONTHS_DATE_FILTER },
  { key: 3, name: 'dashboard.widgets.lastYear', filter: LAST_YEAR_DATE_FILTER },
  { key: 4, name: 'dashboard.widgets.sinceEver', filter: SINCE_EVER_DATE_FILTER }
];

export const DASHBOARD_MONTH_FILTER_INDEX = 1;

export const LAST_MONTH_TIME_PERIOD = 'month';

export const DASHBOARD_TIME_PERIOD_FILTERS = [
  { key: 0, name: 'dashboard.widgets.lastWeek', filter: 'week' },
  { key: 1, name: 'dashboard.widgets.lastMonth', filter: 'month' },
  { key: 2, name: 'dashboard.widgets.lastMonths', filter: 'quarter' },
  { key: 3, name: 'dashboard.widgets.lastYear', filter: 'year' },
  { key: 4, name: 'dashboard.widgets.sinceEver', filter: 'all' },
  { key: 5, name: 'dashboard.widgets.activeSubscription', filter: 'subscription' }
];

export const TIME_PERIOD_MONTH_FILTER_INDEX = 1;

export const NPS_VALUE_STATE = {
  well: 35,
  brilliant: 15
};
